export default {
  name: 'inventaire-historique-modifications',
  props: {
    modifications: { type: Array, default: () => [] },
  },
  methods: {
    modificationLignes(mod) {
      const nouveau = mod && mod.nouveau ? mod.nouveau : {}
      const ancien = mod && mod.ancien ? mod.ancien : {}
      return Object.keys(nouveau).map(produit => ({
        produit,
        ancien: ancien[produit] !== null && ancien[produit] !== undefined ? ancien[produit] : '—',
        nouveau: nouveau[produit] !== null && nouveau[produit] !== undefined ? nouveau[produit] : '—',
      }))
    },
  },
}
